"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { ArrowLeft, ArrowRight, Compass } from "lucide-react";

export default function NotFound() {
  const router = useRouter();

  const handleBack = () => {
    // Go back if there's history, otherwise fall back to home
    if (window.history.length > 1) router.back();
    else router.push("/");
  };

  return (
    <section className="relative flex min-h-[70vh] items-center justify-center overflow-hidden bg-accent/40">
      <div className="pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-80 w-80 rounded-full bg-primary/[0.08] blur-3xl" />
      <div className="container-px relative mx-auto max-w-xl py-24 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary text-white shadow-[0_20px_40px_-14px_rgba(255,122,0,0.5)]">
          <Compass className="h-8 w-8" />
        </div>
        <p className="mt-6 text-sm font-semibold uppercase tracking-widest text-primary">Error 404</p>
        <h1 className="mt-3 text-3xl font-bold text-ink sm:text-4xl">Page not found</h1>
        <p className="mt-4 text-base leading-relaxed text-muted">
          The page you&apos;re looking for doesn&apos;t exist or may have moved. Let&apos;s get you back to
          something useful.
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <button type="button" onClick={handleBack} className="btn-secondary">
            <ArrowLeft className="h-4 w-4" /> Go back
          </button>
          <Link href="/" className="btn-primary">
            Back to home <ArrowRight className="h-4 w-4" />
          </Link>
          <Link href="/contact" className="btn-secondary">
            Contact support
          </Link>
        </div>
      </div>
    </section>
  );
}